<template>
  <div
    class="min-h-[18rem] rounded-3xl bg-neutral-variant-2-pressed flex flex-col gap-[.8rem] px-24 py-20"
    :class="{
      'cursor-pointer group': buttonText
    }"
  >
    <div v-if="status">
      <span class="rounded-full text-xs font-medium px-[6px] py-[3px]" :class="[statusStyles]">
        {{ $t(statusText) }}
      </span>
    </div>
    <div>
      <p class="text-lg leading-lg font-bold text-on-surface-elevation-1 mb-4">
        {{ $t(title) }}
      </p>
      <safe-html
        tag="p"
        class="text-sm leading-md font-regular text-on-surface-elevation-2 break-keep"
        :html="$t(description)"
      />
    </div>
    <span
      v-if="buttonText"
      class="cursor-pointer mt-auto inline-flex items-center gap-4 text-md leading-sm text-on-surface-elevation-2 font-regular"
      @click="$emit('click')"
    >
      <span class="group-hover:underline">{{ $t(buttonText) }}</span>
      <s-icon icon="ic-v2-control-arrow-right-line" size="xl" class="flex" />
    </span>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';

import SafeHtml from '@/components/common/safe-html.vue';
import { RatingGuideItemType } from '@/enums/rating.enum';

const props = defineProps<{
  status?: RatingGuideItemType | null;
  title: string;
  description: string;
  buttonText?: string;
}>();

defineEmits<{
  click: [];
}>();

const statusText = computed(() => {
  switch (props.status) {
    case RatingGuideItemType.Request:
      return 'studio.rating_build_review.required_info_register_stt_in_review';
    case RatingGuideItemType.Reject:
      return 'studio.rating_build_review.required_info_register_stt_rejected';
    case RatingGuideItemType.Approve:
      return 'studio.rating_build_review.required_info_register_stt_completed';
    case RatingGuideItemType.Inputted:
      return 'studio.rating_build_review.required_info_register_stt_input_completion';
    default:
      return '';
  }
});

const statusStyles = computed(() => {
  switch (props.status) {
    case RatingGuideItemType.Request:
      return ['bg-[#FFC226]', 'text-on-surface-elevation-2'];
    case RatingGuideItemType.Reject:
      return ['bg-[#EC3B47]', 'text-white'];
    case RatingGuideItemType.Approve:
    case RatingGuideItemType.Inputted:
      return ['bg-[#6892FF]', 'text-white'];
    default:
      return '';
  }
});
</script>
